(function($) {
    $(window).on('load resize scroll', function(){
        if( $(window).scrollTop() > 100){
            $('.top-nav').addClass('sticky');
        } else {
            $('.top-nav').removeClass('sticky');
        }
    });

    $(".nav-toggle").on('click', function () {
        $(this).add("nav.main-nav").add('.top-nav').toggleClass('open');

        if( $("nav.main-nav").hasClass('open') ){
            $('html').addClass('noscroll');
            $('.main-nav > ul >li:first-child').find('.image').css({
                opacity: 1
            });
        } else {
            $('html').removeClass('noscroll');
        }
    });



    $('.main-nav > ul > li.menu-item-has-children').each(function () {
        if (!$(this).find('.main-nav-nav-toggle').length) {
            $(this).find('.sub-menu').before('<button class="main-nav-nav-toggle"></button>');
        }
    });


    $('.main-nav > ul > li').on('mouseenter', function(){
        if(window.innerWidth > 991) {
            $(this).siblings().removeClass('on');
            $(this).addClass('on');

            $(this).siblings().find('.image').css({
                opacity: 0
            });

            $(this).find('.image').css({
                opacity: 1
            });
        }
    });

    $('.main-nav > ul > li > .main-nav-nav-toggle').on('click', function(e){
        if(window.innerWidth < 992) {
            if($(this).parent().is('.on')){
                $(this).parent().removeClass('on');
                e.preventDefault();
                return false;
            }

            $(this).parent().siblings().removeClass('on');
            $(this).parent().addClass('on');
        }
    });

    $('.main-nav-before').on('click', function(){
        if($('.main-nav').hasClass('open')){
            $('.nav-toggle').click();
        }
    });

    /* Uncomment to add chevron arrow for sub navs
    $('nav.main-nav li.menu-item-has-children').each(function(){
        $(this).children('.sub-menu').before('<button class="main-nav-nav-toggle"></button>');
    });
    */

    $(document).on('click', '.span_select, .quick-links .quick-links-nav-wrapper', function(){
        $(this).toggleClass('closed');
    });

    $(document).on('click', '.span_select span', function(){
        var translation = $(this).attr('data-lang');
        doGTranslate(translation);
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });

    $(document).on('click', function(e){
        if( !$(e.target).is('.span_select') ){
            $('.span_select').addClass('closed');
        }
    });





})( jQuery );

/*(function($) {
    var $nav = $(".mobile-nav");
    $(".nav-toggle").on('click', function () {
       $nav.addClass('show');
       $('body').css({
        overflow: 'hidden'
       });
    });

    $(".nav-close").on("click", function () {
        $nav.removeClass('show');
        $('.mobile-nav-toggle').removeClass('open');
        $('.sub-menu').slideUp();
        $('body').css({
            overflow: ''
       });
    });

    $(window).on('resize', function(){
        if(window.innerWidth > 992){
            $nav.removeClass('show');
        }
    });

    $(window).on('load scroll', function(){
        var wScrollTop = $(window).scrollTop();
        if(wScrollTop > 50){
            $('nav.main-nav').addClass('sticky');
        } else {
            $('nav.main-nav').removeClass('sticky');
        }
    })


    function fixNav($parent){
        //Fix subnav positioning if off the screen
        $parent.find('.sub-menu').each(function(){
            $(this).removeClass('right');
            if( ($(this).offset().left + $(this).outerWidth()) > window.innerWidth  && window.innerWidth > 992){
                $(this).addClass('right');
            }
        });
    }
    $('.main-menu .menu-item').mousemove(function(){
        fixNav($(this));
    });

    fixNav( $('.main-menu') );

    //Only apply columns if there are more than a certain amount of children in sub menu, otherwise just show a single column
    $(document).ready(function(){
        $('nav.main-nav .bottom-nav ul.sub-menu').each(function(){
            if($(this).children('li').length < 7){
                $(this).addClass('single-column');
            }
        });

        //Add dropdown buttons on mobile
        $('.mobile-nav .main > ul > li.menu-item-has-children').each(function(){
            $(this).children('.sub-menu').before('<button class="mobile-nav-toggle fa-solid fa-caret-down"></button>');
        });

        var $navSliding = false;
        $(document).on('mousedown touchend', '.mobile-nav-toggle', function(e){
            e.preventDefault();
            var ele = $(this);

            if($navSliding == true)
                return;

            $navSliding = true;

            if(!ele.hasClass('open')){
                $('.mobile-nav-toggle').removeClass('open').next('.sub-menu').slideUp();
                ele.addClass('open');
                ele.next('.sub-menu').slideDown(function(){
                    $navSliding = false;
                });

            } else {
                ele.removeClass('open');
                ele.next('.sub-menu').slideUp(function(){
                    $navSliding = false;
                });
            }

            return false;
        });
    });


})( jQuery );*/
